import { z } from 'zod';

export const OTPStatusSchema = z.enum(['sent', 'verified', 'expired']);
export type OTPStatus = z.infer<typeof OTPStatusSchema>;
